import { Injectable } from "@angular/core";
import { ICONS, Port } from "../../../../links.model";

/**
 * Serviço responsável por gerênciar os ícones de marcações de portas na modal de links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkDevicePortIconsService {

    public static readonly ICON_PORT_LINKED = ICONS.PORT_LINKED;

    public getLinkIconLabel(iconName): string {
        return `${iconName.replace(/_/g, ".")}.label`;
    }

    public getLinkIcons(): Array<string> {
        return Object.values(ICONS);
    }

    public getPortIcons(isDwdm: boolean, port: Port): Array<string> {
        const icons = [];

        if (!isDwdm && port) {
            icons.push(this.getIcon(port.linked, ICONS.PORT_LINKED));
            icons.push(this.getIcon(port.memberOfPortChannel, ICONS.PCM_LINK));
            icons.push(this.getIcon(port.hasRdmEnabled, ICONS.RDM_LINK));
            icons.push(this.getIcon(port.backupLinkMain, ICONS.BLM_LINK));
            icons.push(this.getIcon(port.backupLinkAlternative, ICONS.BLA_LINK));
            icons.push(this.getIcon(port.mplsUplink, ICONS.MPLS_LINK));
            icons.push(this.getIcon(port.privateVlanPortInterSwitch, ICONS.PVLAN_INTERSWITCH_PORT));
            icons.push(this.getIcon(port.privateVlanPortPromiscuous, ICONS.PVLAN_PROMISCUOUS_PORT));
            icons.push(this.getIcon(port.privateVlanPortCommunity, ICONS.PVLAN_COMMUNITY_PORT));
            icons.push(this.getIcon(port.privateVlanPortIsolated, ICONS.PVLAN_ISOLATED_PORT));
        }

        return icons.filter(Boolean);
    }

    private getIcon(hasPortAttribute: boolean, icon: string): string {
        return hasPortAttribute ? icon : null;
    }
}
